import { render, staticRenderFns } from "./SampleProcessingTabPhoto.vue?vue&type=template&id=3d6703fa&scoped=true&"
import script from "./SampleProcessingTabPhoto.vue?vue&type=script&lang=js&"
export * from "./SampleProcessingTabPhoto.vue?vue&type=script&lang=js&"
import style0 from "./SampleProcessingTabPhoto.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SampleProcessingTabPhoto.vue?vue&type=style&index=1&id=3d6703fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6703fa",
  null
  
)

export default component.exports